export default __webpack_public_path__ + "img/field-time.362841.svg";